<template>
    <svg class="IconFlowGraphContain" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path
          d="M13.728,12.167a3.335,3.335,0,0,1-6.457,0H3V10.5H7.272a3.335,3.335,0,0,1,6.457,0H18v1.667H13.728ZM10.5,13a1.667,1.667,0,1,0-1.667-1.667A1.667,1.667,0,0,0,10.5,13Z"
          transform="translate(-0.5 -1.334)"
          :fill="color"
      />
    </svg>
</template>

<script>
import IconBase from '@/components/icons/IconBase'

export default {
    name: 'IconFlowGraphContain',
    extends: IconBase
}
</script>

<style scoped lang="scss">

</style>
